import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["srcdoc"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.emailHtml)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 0,
          class: "email-frame",
          sandbox: "allow-popups allow-popups-to-escape-sandbox",
          referrerpolicy: "no-referrer",
          srcdoc: _ctx.emailHtml
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}